import { render, staticRenderFns } from "./reForInfo.vue?vue&type=template&id=14947ffe&scoped=true&"
import script from "./reForInfo.vue?vue&type=script&lang=js&"
export * from "./reForInfo.vue?vue&type=script&lang=js&"
import style0 from "./reForInfo.vue?vue&type=style&index=0&id=14947ffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14947ffe",
  null
  
)

export default component.exports